module.exports = __webpack_public_path__ + "assets/icon-search-data-component.7368ab2d.svg";